import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { AnalyticService } from 'src/app/core/service/analytic.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-analytic-view',
  templateUrl: './analytic-view.component.html',
  styleUrls: ['./analytic-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AnalyticViewComponent
{
  @Input() public id: number;

  public frameHeight = '100vh';
  public url: string;

  /**
   * Subscription to Angular component route.
   */
  public routeParamSubscription: Subscription;

  constructor(
    private analyticService: AnalyticService,
    private route: ActivatedRoute,
    private messageHandlerService: MessageHandlerService,
  )
  {
    this.routeParamSubscription = this.route.params.subscribe({
      next: (params: Params) =>
      {
        this.id = +params.id;
        this.getAnalytic();
      }
    });
  }

  public onResized(): void
  {
    this.frameHeight = `${window.innerHeight - 120}px`;
  }

  private getAnalytic(): void
  {
    this.analyticService.getAnalyticById(this.id).subscribe({
      next: (data) =>
      {
        this.url = data.link;
      },
      error: (errorResponse: any) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }
}
